import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RouletPhysicsService {
  win: any;
  private loose: any;
  isWin: boolean = false;
  winParams = {
    "50.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 20,
      r: 500,
      cofficient: 0.005,
      rt: 0.0014,
      cf: 2.22,
      k: 0.001,
      tp: [-50, 705, -320],
      tr: [0, 0, 0],
      tp_o: [-50, 705, 320],
      tr_o: [0, 0, Math.PI],
      ts: [0, 0, 0]

    },
    "33.3": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 53,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.42,
      k: 0.001,
      tp: [-250, 705, -200],
      tr: [0, 0, Math.PI / 4],
      tp_o: [150, 705, 200],
      tr_o: [0, 0, Math.PI / 0.8],
      ts: [0, 0, 0]

    },
    "66.7": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 52,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.42,
      k: 0.001,
      tp: [150, 705, -280],
      tr: [0, 0, - Math.PI / 5],
      tp_o: [-250, 705, 290],
      tr_o: [0, 0, Math.PI / 1.3],
      ts: [0, 0, 0]

    },
    "25.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 53,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.43,
      k: 0.001,
      tp: [-290, 705, -150],
      tr: [0, 0, Math.PI / 3.6],
      tp_o: [200, 705, 120],
      tr_o: [0, 0, Math.PI / 0.75],
      ts: [0, 0, 0]

    },
    "28.6": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 53,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.43,
      k: 0.001,
      tp: [-250, 705, -200],
      tr: [0, 0, Math.PI / 4],
      tp_o: [170, 703, 160],
      tr_o: [0, 0, Math.PI / 0.78],
      ts: [0, 0, 0]

    },
    "20.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 25,
      r: 500,
      cofficient: 0.005,
      rt: 0.001,
      cf: 2,
      k: 0.001,
      tp: [-300, 705, -120],
      tr: [0, 0, Math.PI / 3],
      tp_o: [200, 705, 120],
      tr_o: [0, 0, Math.PI / 0.75],
      ts: [0, 0, 0]

    },
    "16.7": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 53,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.43,
      k: 0.001,
      tp: [-300, 705, -120],
      tr: [0, 0, Math.PI / 3],
      tp_o: [200, 705, 120],
      tr_o: [0, 0, Math.PI / 0.75],
      ts: [0, 0, 0]

    },
    "14.3": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 53,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.44,
      k: 0.00003,
      tp: [-315, 705, -60],
      tr: [0, 0, Math.PI / 2.5],
      tp_o: [210, 705, 60],
      tr_o: [0, 0, Math.PI / 0.73],
      ts: [0, 0, 0]

    },
    "12.5": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 53,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.44,
      k: 0.00003,
      tp: [-315, 705, -60],
      tr: [0, 0, Math.PI / 2.5],
      tp_o: [210, 705, 60],
      tr_o: [0, 0, Math.PI / 0.73],
      ts: [0, 0, 0]

    },
    "11.1": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 59,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.48,
      k: 0.00005,
      tp: [-325, 705, -20],
      tr: [0, 0, Math.PI / 2.4],
      tp_o: [220, 705, 40],
      tr_o: [0, 0, Math.PI / 0.72],
      ts: [0, 0, 0]

    },
    "10.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 25,
      r: 500,
      cofficient: 0.005,
      rt: 0.001,
      cf: 2,
      k: 0.001,
      tp: [-325, 705, -20],
      tr: [0, 0, Math.PI / 2.45],
      tp_o: [220, 705, 40],
      tr_o: [0, 0, Math.PI / 0.72],
      ts: [0, 0, 0]

    },
    "30.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 23.4,
      r: 500,
      cofficient: 0.005,
      rt: 0.0011,
      cf: 2.1,
      k: 0.001,
      tp: [-260, 705, -205],
      tr: [0, 0, Math.PI / 5],
      tp_o: [110, 705, 240],
      tr_o: [0, 0, Math.PI / 0.85],
      ts: [0, 0, 0]

    },
    "37.5": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 52.5,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.44,
      k: 0.00003,
      tp: [-180, 705, -265],
      tr: [0, 0, Math.PI / 8],
      tp_o: [110, 705, 240],
      tr_o: [0, 0, Math.PI / 0.85],
      ts: [0, 0, 0]

    },
    "40.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 23.4,
      r: 500,
      cofficient: 0.005,
      rt: 0.0011,
      cf: 2.1,
      k: 0.001,
      tp: [-180, 705, -275],
      tr: [0, 0, Math.PI / 8],
      tp_o: [110, 705, 250],
      tr_o: [0, 0, Math.PI / 0.85],
      ts: [0, 0, 0]

    },
    "42.9": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 52.5,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.44,
      k: 0.00003,
      tp: [-180, 705, -265],
      tr: [0, 0, Math.PI / 8],
      tp_o: [110, 705, 240],
      tr_o: [0, 0, Math.PI / 0.85],
      ts: [0, 0, 0]

    },
    "57.1": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 45,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.36,
      k: 0.001,
      tp: [50, 705, -325],
      tr: [0, 0, - Math.PI / 8],
      tp_o: [-150, 705, 315],
      tr_o: [0, 0, Math.PI / 1.1],
      ts: [0, 0, 0]

    },
    "60.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 20,
      r: 500,
      cofficient: 0.005,
      rt: 0.0014,
      cf: 2.22,
      k: 0.001,
      tp: [50, 705, -325],
      tr: [0, 0, - Math.PI / 8],
      tp_o: [-150, 705, 315],
      tr_o: [0, 0, Math.PI / 1.1],
      ts: [0, 0, 0]

    },
    "62.5": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 45,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.36,
      k: 0.001,
      tp: [50, 705, -325],
      tr: [0, 0, - Math.PI / 8],
      tp_o: [-150, 705, 315],
      tr_o: [0, 0, Math.PI / 1.1],
      ts: [0, 0, 0]

    },
    "70.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 20,
      r: 500,
      cofficient: 0.005,
      rt: 0.0013,
      cf: 2,
      k: 0.001,
      tp: [150, 705, -280],
      tr: [0, 0, - Math.PI / 5],
      tp_o: [-270, 705, 270],
      tr_o: [0, 0, Math.PI / 1.3],
      ts: [0, 0, 0]

    },
    "71.4": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 48,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.38,
      k: 0.00003,
      tp: [150, 705, -280],
      tr: [0, 0, - Math.PI / 5],
      tp_o: [-270, 705, 270],
      tr_o: [0, 0, Math.PI / 1.3],
      ts: [0, 0, 0]

    },
    "75.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 48,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.38,
      k: 0.00003,
      tp: [150, 705, -280],
      tr: [0, 0, - Math.PI / 5],
      tp_o: [-270, 705, 270],
      tr_o: [0, 0, Math.PI / 1.3],
      ts: [0, 0, 0]

    },
    "80.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 20,
      r: 500,
      cofficient: 0.005,
      rt: 0.0013,
      cf: 2,
      k: 0.001,
      tp: [250, 705, -200],
      tr: [0, 0, - Math.PI / 3],
      tp_o: [-320, 705, 240],
      tr_o: [0, 0, Math.PI / 1.4],
      ts: [0, 0, 0]

    },
    "83.3": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 48,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.38,
      k: 0.00003,
      tp: [250, 705, -200],
      tr: [0, 0, - Math.PI / 3],
      tp_o: [-350, 705, 200],
      tr_o: [0, 0, Math.PI / 1.5],
      ts: [0, 0, 0]

    },
    "85.7": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 48,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.38,
      k: 0.00003,
      tp: [250, 705, -200],
      tr: [0, 0, - Math.PI / 3],
      tp_o: [-350, 705, 200],
      tr_o: [0, 0, Math.PI / 1.5],
      ts: [0, 0, 0]

    },
    "87.5": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 48,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.38,
      k: 0.00003,
      tp: [250, 705, -200],
      tr: [0, 0, - Math.PI / 3],
      tp_o: [-350, 705, 210],
      tr_o: [0, 0, Math.PI / 1.5],
      ts: [0, 0, 0]

    },
    "87.7": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 48,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.38,
      k: 0.00003,
      tp: [250, 705, -200],
      tr: [0, 0, - Math.PI / 3],
      tp_o: [-350, 705, 200],
      tr_o: [0, 0, Math.PI / 1.5],
      ts: [0, 0, 0]

    },
    "90.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 20,
      r: 500,
      cofficient: 0.005,
      rt: 0.0013,
      cf: 2,
      k: 0.001,
      tp: [250, 705, -200],
      tr: [0, 0, - Math.PI / 3],
      tp_o: [-380, 705, 170],
      tr_o: [0, 0, Math.PI / 1.65],
      ts: [0, 0, 0]

    },
    "22.2": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 58.5,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.48,
      k: 0.00005,
      tp: [-300, 705, -115],
      tr: [0, 0, Math.PI / 3],
      tp_o: [200, 705, 120],
      tr_o: [0, 0, Math.PI / 0.75],
      ts: [0, 0, 0]

    },
    "44.4": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 53,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.42,
      k: 0.001,
      tp: [-180, 705, -265],
      tr: [0, 0, Math.PI / 8],
      tp_o: [50, 705, 270],
      tr_o: [0, 0, Math.PI / 0.89],
      ts: [0, 0, 0]

    },
    "55.5": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 45,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.36,
      k: 0.001,
      tp: [50, 705, -325],
      tr: [0, 0, - Math.PI / 8],
      tp_o: [-150, 705, 315],
      tr_o: [0, 0, Math.PI / 1.1],
      ts: [0, 0, 0]

    },
    "55.6": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 45,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.36,
      k: 0.001,
      tp: [50, 705, -325],
      tr: [0, 0, - Math.PI / 8],
      tp_o: [-150, 705, 315],
      tr_o: [0, 0, Math.PI / 1.1],
      ts: [0, 0, 0]

    },
    "66.6": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 45,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.36,
      k: 0.001,
      tp: [50, 705, -325],
      tr: [0, 0, - Math.PI / 8],
      tp_o: [-150, 705, 315],
      tr_o: [0, 0, Math.PI / 1.1],
      ts: [0, 0, 0]

    },

    "77.7": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 48,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.38,
      k: 0.00003,
      tp: [150, 705, -280],
      tr: [0, 0, - Math.PI / 5],
      tp_o: [-270, 705, 270],
      tr_o: [0, 0, Math.PI / 1.3],
      ts: [0, 0, 0]

    },
    "77.8": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 48,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.38,
      k: 0.00003,
      tp: [150, 705, -280],
      tr: [0, 0, - Math.PI / 5],
      tp_o: [-300, 705, 260],
      tr_o: [0, 0, Math.PI / 1.36],
      ts: [0, 0, 0]

    },
    "88.9": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 48,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.38,
      k: 0.00003,
      tp: [250, 705, -200],
      tr: [0, 0, - Math.PI / 3],
      tp_o: [-380, 705, 170],
      tr_o: [0, 0, Math.PI / 1.67],
      ts: [0, 0, 0]

    }
  };
  looseParams = {
    "50.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 20,
      r: 500,
      cofficient: 0.005,
      rt: 0.00125,
      cf: 1.9,
      k: 0.001

    },
    "57.1": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 60,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.5,
      k: 0.001,

    },
    "67.7": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 55,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.45,
      k: 0.001,

    },
    "33.3": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 54,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.44,
      k: 0.001,

    },
    "75.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 54,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.44,
      k: 0.001,

    },
    "10.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 25,
      r: 500,
      cofficient: 0.005,
      rt: 0.00105,
      cf: 2,
      k: 0.001

    },
    "11.1": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 59.5,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.48,
      k: 0.000045,

    },
    "12.5": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 59.5,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.48,
      k: 0.000045,

    },
    "14.3": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 59.5,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.48,
      k: 0.000045,

    },
    "16.7": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 49.4,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.4,
      k: 0.000045,

    },
    "20.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 24,
      r: 500,
      cofficient: 0.005,
      rt: 0.00115,
      cf: 2.2,
      k: 0.001

    },
    "22.2": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 49.4,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.4,
      k: 0.000045,

    },
    "25.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 49.4,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.4,
      k: 0.000045,

    },
    "28.6": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 49.4,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.4,
      k: 0.000045,

    },
    "30.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 24,
      r: 500,
      cofficient: 0.005,
      rt: 0.00115,
      cf: 2.2,
      k: 0.001

    },
    "37.5": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 50,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.4,
      k: 0.000045,

    },
    "40.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 22,
      r: 500,
      cofficient: 0.005,
      rt: 0.0015,
      cf: 2.5,
      k: 0.001

    },
    "42.9": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 50,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.4,
      k: 0.000045,

    },
    "44.4": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 50,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.4,
      k: 0.000045,

    },
    "55.5": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 55,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.45,
      k: 0.001,

    },
    "55.6": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 55,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.45,
      k: 0.001,

    },
    "60.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 20,
      r: 500,
      cofficient: 0.005,
      rt: 0.00125,
      cf: 1.92,
      k: 0.001

    },
    "62.2": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 55,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.45,
      k: 0.001,

    },
    "62.5": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 55,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.45,
      k: 0.001,

    },
    "66.6": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 55,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.45,
      k: 0.001,

    },
    "66.7": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 54,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.44,
      k: 0.001,

    },
    "70.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 19.8,
      r: 500,
      cofficient: 0.005,
      rt: 0.00125,
      cf: 1.92,
      k: 0.001

    },
    "71.4": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 55,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.45,
      k: 0.001,

    },
    "77.7": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 55,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.45,
      k: 0.001,

    },
    "77.8": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 55,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.45,
      k: 0.001,

    },
    "80.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 19.8,
      r: 500,
      cofficient: 0.005,
      rt: 0.00125,
      cf: 1.92,
      k: 0.001

    },
    "83.3": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 55,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.45,
      k: 0.001,

    },
    "85.7": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 55,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.45,
      k: 0.001,

    },
    "87.5": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 55,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.45,
      k: 0.001,

    },
    "87.7": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 55,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.45,
      k: 0.001,

    },
    "88.9": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 55,
      r: 500,
      cofficient: 0.005,
      rt: 0.0001,
      cf: 0.45,
      k: 0.001,

    },
    "90.0": {
      Q: Math.PI / 31.4,
      w: Math.PI / 31.4,
      a: Math.PI / 20,
      r: 500,
      cofficient: 0.005,
      rt: 0.00125,
      cf: 1.95,
      k: 0.001

    }
  }
  constructor() { }

  set(win, isWin) {
    this.win = Number(win).toFixed(1);
    this.loose = (100 - Number(this.win)).toFixed(1);
    this.isWin = isWin;
  }

  get() {
    if (this.isWin) {
      return this.winParams[this.win];
    }
    return this.looseParams[this.loose];
  }
}
